import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RomanticPersonalizedReport from "./component";
import {
  createGuestUser,
  getBilling,
  getGuestUser,
  getOrderDataByUserId,
  GetUserById,
  isGuestOrPremiumUser,
} from "../settings/actions";
import {
  getInsightfulContent,
  sendToPartnerReportOnEmail,
  sendToFriendReportOnEmail,
  getAssessment,
  getAssessmentAttemptByUserId,
} from "../dashboard/actions";
import { getAssessmentResultByAssessmentAttemptId } from "../plan/actions";
import SocialAnxietyReportReport from "./component";
import SocialAnxietyReport from "./component";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInsightfulContentConnect: getInsightfulContent,
      getAssessmentResultByAssessmentAttemptIdConnect:
        getAssessmentResultByAssessmentAttemptId,
      getUserByIdConnect: GetUserById,
      sendToPartnerReportOnEmailConnect: sendToPartnerReportOnEmail,
      sendToFriendReportOnEmailConnect: sendToFriendReportOnEmail,
      getGuestUserConnect: getGuestUser,
      isGuestOrPremiumUserConnect: isGuestOrPremiumUser,
      getAssessmentConnect: getAssessment,
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,

      getOrderDataByUserIdConnect: getOrderDataByUserId,
      guestUserChangesConnect: createGuestUser,
      getBillingConnect: getBilling,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SocialAnxietyReport);
